import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { VasState, Item } from '@/store/Vas/state';
import getters from './getters';
import mutations from './mutations';

import { VasConfig } from '@/data/vasConfig';
import { Vas } from '@/data/vas/vas';

const config = new VasConfig();

const initialize = (): Item[] => {
  return config.list.reduce((z: Item[], vas: Vas) => {
    z.push({ id: vas.id, count: 0 });
    return z;
  }, []);
};

const state: VasState = {
  vas: initialize(),
};

export const vas: Module<VasState, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
};
